import { useCatalogStore } from '../store/catalogStore';

export default function CollectorTierBadge({
  tierId,
  level,
}: {
  tierId: string | null | undefined;
  level?: number | null;
}) {
  const tier = useCatalogStore((s) => s.meta?.collectorTiers.find((t) => t.id === tierId));
  if (!tierId || !tier) return null;

  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-mlbb-border/60 py-1 pl-1 pr-2.5 text-xs font-medium text-white">
      <img src={tier.icon} alt="" className="h-5 w-5 rounded-full object-cover" />
      {tier.name}
      {level ? ` ${level}` : ''}
    </span>
  );
}
